// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmployeeCardList_wrapper__7XAHD","heading":"EmployeeCardList_heading__HYN1v","cardList":"EmployeeCardList_cardList__oiBwn"};